import * as React from "react";

import api from "kw/api";
import { riskProfileFields } from "kw/api/fragments";

export function useRiskProfilePolicy(riskProfileId) {
  const [riskProfile, setRiskProfile] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    async function effect() {
      const response = await api.query(getRiskProfileQuery(riskProfileId));
      setRiskProfile(response.riskProfile);
      setLoading(false);
    }
    effect();
  }, [riskProfileId]);
  return [riskProfile, { loading }];
}

export function getRiskProfileQuery(riskProfileId) {
  return {
    riskProfile: [
      {
        id: riskProfileId,
      },
      {
        ...riskProfileFields,
        startDate: true,
        finishDate: true,
        policyPeriods: {
          policy: {
            id: true,
            policyNumber: true,
            currentPeriod: {
              latestTransaction: {
                amount: true,
                paymentProfile: {
                  customerReference: true,
                },
                amountWithSurcharge: true,
              },
            },
          },
          documents: {
            type: true,
            url: true,
            name: true,
          },
        },
        asParentInBundledRiskProfiles: {
          id: true,
          riskProfiles: {
            ...riskProfileFields,
            policyPeriods: {
              policy: {
                id: true,
                policyNumber: true,
                currentPeriod: {
                  latestTransaction: {
                    amount: true,
                    paymentProfile: {
                      customerReference: true,
                    },
                    amountWithSurcharge: true,
                  },
                },
              },
              documents: {
                type: true,
                url: true,
                name: true,
              },
            },
          },
        },
      },
    ],
  };
}
